import { Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect,useRef } from "react";
import ImageUploading from 'react-images-uploading';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { auth } from "../firebase/firebaseDb.js";
import { ToastContainer, toast } from 'react-toastify';
import Header from "../components/Header";
import {GeneratingBanner} from "../components/Dashboardbanner";
import { useTranslation } from "react-i18next";
import { Modal } from "bootstrap";
import { Atom,Mosaic } from "react-loading-indicators";

import { 
FacebookAuthProvider,
 GoogleAuthProvider,
 signInWithPopup ,
 signInWithRedirect,
 OAuthProvider,
 sendSignInLinkToEmail,
 createUserWithEmailAndPassword,
 signInWithEmailAndPassword,
 updateProfile,
 sendEmailVerification,
 onAuthStateChanged
 } from "firebase/auth";

const CARDS_PER_PAGE = 6;

export default function Dashboard() {
	
	 const modalRef = useRef();
	  
	   const [selectedServiceName, setSelectedServiceName] = useState('');
       const [selectedServiceDescription, setSelectedServiceDescription] = useState('');
	   const [serviceMode, setServiceMode] = useState('save');
	   const [oldServiceName, setOldServiceName] = useState('');
	   
	   const [businessName, setBusinessName] = useState('');
	   const [businessType, setBusinessType] = useState('');
	   const [businessAddress, setBusinessAddress] = useState('');
	   const [businessEmail, setBusinessEmail] = useState('');
	   const [businessPhone, setBusinessPhone] = useState('');
	    const [services, setServices] = useState([]);
	   const [images, setImages] = React.useState([]);
  	   
		
	   const [step, setStep] = useState(0);
	   const [inputReply, setInputReply] = useState('');
	    const [showInputReply, setShowInputReply] = useState('flex');
	 const [showSpinner, setShowSpinner] = useState('none');	
	   const [stepInput,setStepInput]=useState('');
	   const maxNumber = 15;
	   const [websiteGeneratorStatus, setWebsiteGeneratorStatus] = useState('');
	  const [remoteImages, setRemoteImages] = useState([]); 
   const [createdWebsiteID, setCreatedWebsiteID] = useState('');	  
	   const [openAIResult, setOpenAIResult]=useState(null);
	   const [urlPath, setUrlPath]=useState('');
	  const [userInfo, setUserInfo]=useState(JSON.parse(localStorage.getItem('user_info'))); 
   const [firebaseUserInfo, setFirebaseUserInfo]=useState(JSON.parse(localStorage.getItem('firebase_user'))); 
    const [websitesList, setWebsitesList]=useState([]);   
    const [websiteLoadState, setWebsiteLoadState]=useState('loading');
	 const [showModalLoader, setShowModalLoader]=useState('none'); 
	 const [generatingBanner, setGeneratingBanner] = useState(null);
	 const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
	 const [currentPage, setCurrentPage] = useState(1);
	// const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
	 
	  
	 const questions = [
    "Let's get started! What's the name of your business?",
    "Which type of activity are your business serve?",
    "Where is your business located?",
	"What's your email",
	"What is your phone number",
    "What's your business products or services?",
	"Choose few images in your library that will be use for your website"
  ];

  const placeholders = [
     "eg ZuriBuild Inc.",
	"eg barbershop",
    "eg Lagos, Nigeria",
    "eg example@email.com",
	"Your phone number",
	"Services / products",
	"Images gallery"
  ];
  
  const WP_API = "http://localhost/zuribuild/wp-json/wp/v2/pages";
const USERNAME = "kevin_joel";
const APP_PASSWORD = "KB2t qtrb bVqD zzJD iP9A 6irA";
const token = btoa(`${USERNAME}:${APP_PASSWORD}`);

const navigate = useNavigate();
const { t } = useTranslation();

	 useEffect(() => {
		   if (!localStorage.getItem('user_info')) {
      navigate('/login');
      return;
    }
   console.log(firebaseUserInfo.email)
getAllWebsites();

   const flag = localStorage.getItem('zuribuild_generating');
  if (flag) {
    try {
      const parsed = JSON.parse(flag);
      const age = Date.now() - parsed.timestamp;
       if (age < 5 * 60 * 1000) setGeneratingBanner(parsed);
       else localStorage.removeItem('zuribuild_generating');
    } catch(e) { localStorage.removeItem('zuribuild_generating'); }
  }
  }, []);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 767);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 767);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

useEffect(() => {
  if (!generatingBanner || websitesList.length === 0) return;
  const found = websitesList.find(w =>
    w.website_name?.toLowerCase() === generatingBanner.businessName?.toLowerCase()
  );
  if (found) {
    localStorage.removeItem('zuribuild_generating');
    setGeneratingBanner(null);
  }
}, [websitesList, generatingBanner]);

const changeTheme= async () =>{
    try {
        const response = await axios.post(
		    process.env.REACT_APP_ZURIBUILD_WORDPRESS_CURRENT_CLUSTER_DOMAIN_URL+"zuribuild/wp-json/custom/v1/switch-theme",
			{ site_id:24, theme: "kadence" },
            { headers: { Authorization: `Basic ${token}`, 'Content-Type': 'application/json' } }
        );
        console.log('Theme changed successfully:', response);
    } catch (error) {
        console.error('Error changing theme:', error.response ? error.response.data : error.message);
    }
}

const  getAllWebsites= async () => {
	setWebsiteLoadState('loading');
	  const payload={ member_id: firebaseUserInfo.uid }
	  axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/get-websites.php", payload, {
      headers: { "Content-Type": "application/json" }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
  if(res.data.length==0){ setWebsiteLoadState("loaded"); }
  else{ setWebsitesList(res.data); setWebsiteLoadState("loaded"); setCurrentPage(1); }
    })
    .catch((err) => {
		setWebsiteLoadState("loaded");
      console.error("Error:", err.message);
	   toast.error(err.message, { position: 'bottom-right' });
    });
};

   const handleNext = () => {
	   if (step < questions.length - 1) {
	if(step==0){
		if(businessName==''){ alert("this have to be filled") }
		else{ checkBusinessName(businessName) }
	}
 if(step==1){
	 if(businessType==''){ setShowInputReply('flex '); setInputReply('This field is required ') }
	 else{ setShowInputReply('none'); setInputReply(''); setStep(step + 1); }
 }	
 if(step==2){
	 if(businessAddress==''){ setShowInputReply('flex '); setInputReply('This field is required ') }
	 else{ setShowInputReply('none'); setInputReply(''); setStep(step + 1); }
 }
 if(step==3){
	 if(businessEmail==''){ setShowInputReply('flex '); setInputReply('This field is required ') }
	 else{ setShowInputReply('none'); setInputReply(''); setStep(step + 1); }
 } 
  if(step==4){
	 if(businessPhone==''){ setShowInputReply('flex '); setInputReply('This field is required ') }
	 else{ setShowInputReply('none'); setInputReply(''); setStep(step + 1); }
 }
   if(step==5){ setStep(step + 1); }
	   }
  };

  const checkBusinessName=async()=>{
	  setShowSpinner('inline-block')
	  const payload={ website_name:businessName }
	  axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/search-website.php", payload, {
      headers: { "Content-Type": "application/json" }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	  if(res.data=='Business no found'){ setStep(step + 1); setShowInputReply('none'); setInputReply('') }
	  else{ setShowInputReply('flex'); setInputReply('This business name already taken. You have to choose another name') }
    })
    .catch((err) => { setShowSpinner('none'); console.error("Error:", err); alert(err) });
  }

   const onChangeImage = (imageList, addUpdateIndex) => {
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const checkBusinessNameAvailability=()=>{}
  
    const handleBack = () => {
		setShowInputReply('none '); setInputReply('');
    if (step > 0) { setStep(step - 1); }
  };

  const goToCredit=()=>{
	    const el = document.getElementById("exampleModal");
    const modal = Modal.getInstance(el);
    modal.hide();
	setTimeout(function() { navigate('/credit'); }, 500); 
  }

    const addNewService = () => {
 const modal = window.bootstrap.Modal.getInstance(modalRef.current);
  if(serviceMode=='save'){
	  setServices([...services,{name:selectedServiceName, description:selectedServiceDescription}]);
	   modal.hide(); setSelectedServiceName(''); setSelectedServiceDescription(''); setServiceMode('save');
  }
  else if(serviceMode=='edit'){
 setServices((prevServices) =>
      prevServices.map((service) =>
        service.name === oldServiceName
          ? { name: selectedServiceName, description: selectedServiceDescription }
          : service
      )
    );
	  setServiceMode('save'); modal.hide(); setSelectedServiceName(''); setSelectedServiceDescription('');
  }
  };

  const progress = ((step + 1) / questions.length) * 100;

  const handleServiceChange = (index, field, value) => {
    const newServices = [...services];
    newServices[index][field] = value;
    setServices(newServices);
  };

  const addService = () => { setServices([...services, { name: "", description: "" }]); };

  const removeService = (name) => {
    setServices((prevServices) => prevServices.filter((service) => service.name !== name));
  };

	const viewService = (name,description) => {
  setServiceMode('edit'); setOldServiceName(name); setSelectedServiceName(name); setSelectedServiceDescription(description);
  const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.show();
  };

	const closeModal = () => {
  setSelectedServiceName(''); setSelectedServiceDescription('');
  const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.hide();
  };

const replaceService = (oldName, newService) => {
  setServices((prevServices) =>
    prevServices.map((service) => service.name === oldName ? newService : service)
  );
};

function normalizeBusinessName(name) {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return words.length > 1 ? words.join("-") : words[0];
}

function convertJsonToWpBlocks(pageJson) {
  let content = "";
  pageJson.sections.forEach((section) => {
    content += `<!-- wp:group {"className":"custom-section"} -->
      <div class="wp-block-group custom-section">
        <h2>${section.title}</h2>
        <p>${section.paragraph}</p>
      </div>
    <!-- /wp:group -->`;
	if(section.images && section.images.length > 0){
		section.images.forEach((img) =>{
		content +=` <!-- wp:image {"url":"${img.url}","alt":"${img.alt || section.title}"} -->
		<div class="wp-block-image"><img src="${img.url}" class="section-image"/></div>
		 <!-- /wp:image -->`;
		});
	}
  }); 
  return content;
}

const createNewWebsite=async()=>{
	var formattedBusinessName=normalizeBusinessName(businessName)
	 try {
    const path = businessName.toLowerCase().replace(/\s+/g, '-');
	 const response = await axios.post(process.env.REACT_APP_ZURIBUILD_WORDPRESS_CURRENT_CLUSTER_DOMAIN_URL+'zuribuild/wp-json/custom/v1/create-site/', {
      path: 'zuribuild/'+formattedBusinessName, title: businessName,
	  domain: process.env.REACT_APP_WORDPRESS_DOMAIN_NAME, template: 'bravada'
    }, { headers: { "Content-Type": "application/json", Authorization: `Basic ${token}` } });
    console.log('New site created:', response.data);
	setUrlPath('zuribuild/'+formattedBusinessName);
	saveWebsiteClientInformationToDatabase(businessName,'zuribuild/'+formattedBusinessName);
    console.log('Visit the site at:', response.data.url);
    return response.data.url;
  } catch (error) {
	  alert(error.message);
    console.error('Error creating website:', error.response?.data || error.message);
  }
}

const saveWebsiteClientInformationToDatabase=async(website_name,wp_url)=>{
	 setShowSpinner('inline-block')
	  const payload={ website_name:website_name, wp_url: wp_url, id:1, created_at: new Date(), expiry_date: new Date() }
	  axios.post("http://localhost/zuribuildAPI/add-website.php", payload, { headers: { "Content-Type": "application/json" } })
    .then((res) => {
		 setShowSpinner('none'); console.log("Response:", res.data);
  alert("Websites added successfully");
 createWebsiteStructureViaAI(wp_url);
 deleteSamplePage(wp_url);	
    })
    .catch((err) => { setShowSpinner('none'); console.error("Error:", err); alert(err) });
}

const deleteSamplePage=async(wp_url)=>{
	axios.delete("http://localhost/zuribuild/"+wp_url+"/wp-json/wp/v2/pages/2", {
 headers: { "Content-Type": "application/json", Authorization: `Basic ${token}` }
}).then(res => { alert("Default page deleted") }).catch(err => { alert(err); console.log(err) });
}

const getNewImagesForWebsite=async()=>{
axios.get('https://api.pexels.com/v1/search', {
    headers: { Authorization: 'hlMsBY7tC1kHzAmGK2M4SwixocehvaIwi5oV0joaWe0HhQA5tS3UDzPq' },
    params: { query: businessType, per_page: 15 },
  })
  .then((response) => {
    console.log("Photos fetched successfully!");
    const photos = response.data.photos;
	setRemoteImages(response.data.photos);
	console.log(photos);
  })
  .catch((error) => {
    if (error.response) { console.error("API responded with error:", error.response.status, error.response.data); }
    else if (error.request) { console.error("No response received:", error.request); }
    else { console.error("Error setting up request:", error.message); }
  });
}

const saveImagesLibray=async()=>{ alert("save images libraries for the current website") }

const createWebsiteStructureViaAI=async(wp_url)=>{
const OPENAI_API_KEY='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';
try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      { model: "gpt-5",
        messages: [
          { role: "system", content: "You are an AI that generates structured JSON for professional websites." },
          { role: "user", content: `Generate a structured JSON for a professional website. 
It must have 4 pages: Home, About, Services, Contact. 
Business Info:
- Name: ${businessName}
- Description: ${businessType}
- Address: ${businessAddress || "Not provided"}
- Email: ${businessEmail || "Not provided"}
- Phone: ${businessPhone || "Not provided"}
- Services: ${JSON.stringify(services || [])}
Use these image URLs where relevant if available:
${images.join("\n")}` }
        ],
      },
      { headers: { Authorization: `Bearer ${OPENAI_API_KEY}`, "Content-Type": "application/json" } }
    );
    const aiContent = response.data.choices[0].message.content;
	console.log(aiContent);
	var segmentizedAIContent=JSON.parse(aiContent);
	 createPagesForWebsite(wp_url,segmentizedAIContent);
  } catch (error) {
    console.error("Error generating site content:", error);
    return null;
  }	
}

const createPagesForWebsite=async(wp_url,content)=>{
	var createdPageNumber=0;
	var pagesCreated=[];
	for (let page of content.pages) {
      const content = convertJsonToWpBlocks(page);
     try{
   const response= await axios.post(
	   "http://localhost/"+wp_url+"/wp-json/wp/v2/pages",
        { title: page.id, content: content, status: "publish",
		  meta: { zb_ai_data: JSON.stringify({ business_name: "Kevin Agency", phone: "+123456" }) }
        },
        { headers: { Authorization: `Basic ${token}`, "Content-Type": "application/json" } }
      );
	  console.log('Page created successfully:', response.data);
	   const pageId = response.data.id;
      const pageTitle = response.data.title.rendered;
      createdPageNumber+=1;
	 }
	 catch (error) {
		 alert(error);
            console.error('Error creating page:', error.response ? error.response.data : error.message);
            throw error;
        }
    }
}

  const handleResend = async () => {
	  const actionCodeSettings={ url: "https//hermanntrucking.ca/login", handleCodeInApp: true }
    if (auth.currentUser) {
      try { await sendEmailVerification(auth.currentUser); alert("Verification email resent! Check your inbox."); }
      catch (error) { alert(error.message); }
    } else { alert("No user is logged in."); }
  };

const goToWizard=async()=>{
	if(JSON.parse(localStorage.getItem('user_info')).credit>0){ navigate("/ai-wizard") }
	else if(JSON.parse(localStorage.getItem('user_info')).credit<=0){
		  const el = document.getElementById("exampleModal");
    const modal = new Modal(el);
    modal.show();
	}
}

const editWebsite=async(wp_url,website_content,site_id)=>{
  setShowModalLoader("flex");
	const res = await fetch(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/create-magic-link.php", {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: firebaseUserInfo.email, site_id: site_id,
	  wp_api: process.env.REACT_APP_ZURIBUILD_WORDPRESS_CURRENT_CLUSTER_DOMAIN_URL+"wp-json/zuribuild/v1/magic-login" })
  });
   setShowModalLoader("none");
  const data = await res.json();
console.log(data);
  if (data.link) { window.location.href=data.link; }
}

const deleteWebsite=async(wordpress_site_id)=>{
	if(window.confirm(t("dashboard.want_to_delete"))){
		 setShowModalLoader("flex");
	  const payload={ wordpress_site_id: wordpress_site_id }
	  axios.post( process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/delete-website.php", payload, {
      headers: { "Content-Type": "application/json" }
    })
    .then((res) => {
		 setShowModalLoader("none"); console.log("Response:", res.data);
	 getAllWebsites();
       toast.success(t("dashboard.website_delete"), { position: 'bottom-right' });
    })
    .catch((err) => {
		 setShowModalLoader("none"); console.error("Error:", err.message);
	   toast.error(err.message, { position: 'bottom-right' });
    });
	}	
}

// ─── Pagination helpers ────────────────────────────────────────────────────────
const totalPages = Math.ceil(websitesList.length / CARDS_PER_PAGE);
const paginatedList = websitesList.slice(
  (currentPage - 1) * CARDS_PER_PAGE,
  currentPage * CARDS_PER_PAGE
);

  return (
  <>
  
  <style>{`
        body {
          margin: 0;
          font-family: 'Inter', -apple-system, sans-serif;
          background-color: #fff;
          color: #000;
        }

        .logo { font-weight: bold; font-size: 20px; color: red; }
        .step { font-size: 14px; font-weight:550; color: #555; }
        .progress-bar { width: 100vw; height: 4px; background-color: rgb(228,228,230); }
        #progress-indicator { height: 4px; background-color: black; transition: width 0.6s ease; }
        .container { display: flex; justify-content: center; align-items: center; width:100%; padding: 40px 20px; }
        .content { width: 100%; }
        h2 { margin-bottom: 20px; font-size: 24px; color: #000; }
        .input-box { width: 100%; height: 50px; border-radius: 25px; border: 1px solid #ccc; padding: 0 15px; font-size: 16px; margin-bottom: 20px; box-sizing: border-box; }
        .btn { width: 100%; height: 50px; border-radius: 25px; border: none; background-color: purple; color: white; font-size: 16px; cursor: pointer; transition: 0.3s; }

        /* ── Website card ── */
        .website-block {
          position: relative;
          width: 300px;
          height: 230px;
          border-radius: 16px;
          overflow: hidden;
          margin: 14px;
          box-shadow: 0 8px 28px rgba(124,58,237,0.18);
          background: #0a0a0a;
          flex-shrink: 0;
        }

        .website-iframe-wrap {
          position: absolute;
          top: 0; left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          pointer-events: none;
          perspective: 600px;
        }

        .website-iframe {
          width: 1280px;
          height: 900px;
          border: none;
          transform: scale(0.234) rotateX(8deg) rotateY(-6deg);
          transform-origin: top left;
          pointer-events: none;
        }

        .website-gradient {
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, rgba(80,0,120,0.15) 0%, rgba(0,0,0,0.7) 55%, rgba(0,0,0,0.97) 100%);
          border-radius: 16px;
        }

        .website-info { position: absolute; bottom: 0; left: 0; right: 0; padding: 12px 14px; z-index: 10; }
        .website-name { color: white; font-weight: 700; font-size: 14px; margin: 0 0 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .website-slug { color: rgba(255,255,255,0.4); font-size: 10px; margin: 0 0 10px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .website-actions { display: flex; gap: 6px; }

        .btn-edit-card { flex: 1; background: rgba(124,58,237,0.92); color: white; border: none; border-radius: 8px; padding: 7px 0; font-size: 12px; font-weight: 600; cursor: pointer; backdrop-filter: blur(4px); }
        .btn-delete-card { background: rgba(220,38,38,0.85); color: white; border: none; border-radius: 8px; padding: 7px 12px; font-size: 12px; cursor: pointer; backdrop-filter: blur(4px); }

        /* ── Pagination ── */
        .pagination-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          padding: 20px 0 10px;
        }

        .page-btn {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: 1px solid #e0e0e0;
          background: white;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          color: #555;
          transition: all 0.15s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .page-btn:hover { background: #f4f0ff; color: #7C3AED; border-color: #7C3AED; }
        .page-btn.active { background: #7C3AED; color: white; border-color: #7C3AED; }
        .page-btn:disabled { opacity: 0.35; cursor: default; }

        .page-info {
          font-size: 12px;
          color: #aaa;
          font-weight: 500;
        }

        @keyframes pulse { 0%, 100% { opacity: 0.3; transform: scale(1); } 50% { opacity: 0.7; transform: scale(1.08); } }

        .modal-backdrop { background-color: rgba(0, 0, 0, 0.7); }
        .fade { padding-bottom:70px; margin-top:70px; opacity: 0; transform: translateY(10px); animation: fadeIn 0.6s ease forwards; }
        @keyframes fadeIn { to { opacity: 1; transform: translateY(0); } }
        .btn:hover { background-color: #5a0e8f; }
        .website-btn { width:55%; }
        .btn-delete { background-color:red; }

        .your-website-title {
          margin-left: 20px !important; text-align:justify !important;
          font-size: 26px !important; font-weight: 800 !important;
          color: black !important; letter-spacing: -1px !important; text-decoration: none !important;
        }

        @media (max-width: 767px) {
          .content { width: 100% !important; }
          .website-block { width: calc(100vw - 32px) !important; height: 220px !important; margin: 8px auto !important; }
          .website-iframe { width: 1280px !important; height: 900px !important; transform: scale(0.285) rotateX(8deg) rotateY(-6deg) !important; transform-origin: top left !important; }
          .your-website-title { margin-left: 20px !important; font-size: 26px !important; font-weight: 800 !important; color: black !important; }
          .block-website-card { width: 100vw !important; align-items: center !important; justify-content: center; flex-direction: column !important; }
        }
      `}</style>

      {generatingBanner && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, background: 'linear-gradient(90deg, #7C3AED, #a855f7)', color: 'white', padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(124,58,237,0.3)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
            <div className="spinner-border spinner-border-sm" style={{ color: 'white', flexShrink: 0 }} />
            <span style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {t("dashboard.generating_banner").replace('{{name}}', generatingBanner.businessName)}
            </span>
          </div>
          <button onClick={() => { localStorage.removeItem('zuribuild_generating'); setGeneratingBanner(null); }}
            style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.4)', color: 'white', borderRadius: 6, padding: '2px 10px', cursor: 'pointer', fontSize: 12, flexShrink: 0, marginLeft: 8 }}>
            {t("dashboard.generating_dismiss")}
          </button>
        </div>
      )}
      {generatingBanner && <div style={{ height: 46 }} />}

      <Header/>

      <div className="container">
        {firebaseUserInfo.emailVerified == false ? (
          <div style={{ marginTop:'30vh', textAlign:'center' }}>
            <h3 style={{ fontWeight:'bold' }}>{t("dashboard.please_verify")}</h3>
            <p style={{ textAlign:'center', color:'gray' }} dangerouslySetInnerHTML={{ __html: t("dashboard.we_sent_you").replace('{{email}}', firebaseUserInfo.email) }} />
            <button type="button" onClick={handleResend} className="btn btn-secondary btn-sm website-btn" style={{ margin:'auto' }}>
              <span className="bi-envelope"></span> {t("dashboard.sent_link")}
            </button>
          </div>
        ) : (
          <div key={step} className="fade">
            <h3 className="your-website-title" style={{ fontSize: '26px !important', fontWeight: '800 !important', color: 'black', letterSpacing: '-1px !important', textDecoration: 'none !important' }}>
              {t("dashboard.website_listing")}
            </h3>

            <div style={{ display:'flex', flexWrap:'wrap', background:'transparent' }}>

              {websitesList.length == 0 ? (
                <div style={{ background:'transparent', width:'80vw', justifyContent:'center', alignItems:'center', display:'flex', flexDirection:'column' }}>
                  {websiteLoadState == 'loaded' ? (
                    <div style={{ marginTop:'5vh' }}>
                      <div style={{ width:'150px', height:'150px', borderRadius:'100px', backgroundColor:'transparent', margin:'auto' }}>
                        <img src="images/empty-result.jpg" style={{ width:'170px' }} />
                      </div>
                      <h3 style={{ color:'purple', textAlign:'center', fontSize: '26px', fontWeight: '800', letterSpacing: '-1px', textDecoration: 'none' }}>{t("dashboard.no_website")}</h3>
                      <p style={{ color:'gray', textAlign:'center', fontSize: '15px', textDecoration: 'none' }}>{t("dashboard.would_you_like")}</p>
                      <button type="button" onClick={getAllWebsites} className="btn btn-secondary btn-sm" style={{ margin:'auto' }}>{t("dashboard.try_again")}</button>
                    </div>
                  ) : (
                    <div style={{ marginTop:'25vh' }}>
                      <div className="spinner-border" role="status" style={{ width:'3rem', height:'3rem', color:'red' }}></div>
                      <p>loading...</p>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  {/* ── Cards grid — only CARDS_PER_PAGE at a time ── */}
                  <div className="block-website-card" style={{ width:'90vw', flexWrap:'wrap', display:'flex' }}>
                    {paginatedList.map((website, index) => (
                      <div key={`${currentPage}-${index}`} className="website-block">

                        {isMobile ? (
                          /* ── MOBILE: static placeholder, no iframe ── */
                          <div style={{
                            position: 'absolute', inset: 0,
                            background: 'linear-gradient(135deg, #1a0a2e 0%, #0a0a0a 100%)',
                            display: 'flex', flexDirection: 'column',
                            alignItems: 'center', justifyContent: 'center',
                            borderRadius: '16px',
                          }}>
                          <img src="/zuribuild.png" style={{
  width: 64,
  opacity: 0.85,
  marginBottom: 10,
  filter: 'drop-shadow(0 4px 12px rgba(124,58,237,0.4))',
}} alt="ZuriBuild" />
                            <img src="/zuribuild.png" style={{ width: 28, opacity: 0.25 }} alt="zuribuild" />
                          </div>
                        ) : (
                          <>
                            {/* Logo placeholder shown while iframe loads */}
                            <div id={`placeholder-${currentPage}-${index}`} style={{
                              position: 'absolute', inset: 0, display: 'flex',
                              flexDirection: 'column', alignItems: 'center',
                              justifyContent: 'center', background: '#0a0a0a',
                              zIndex: 2, borderRadius: '16px',
                            }}>
                              <img src="/zuribuild.png" style={{ width: 48, opacity: 0.5, animation: 'pulse 1.5s ease-in-out infinite' }} alt="loading" />
                            </div>
                            {/* iframe — desktop only */}
                            <div className="website-iframe-wrap">
                              <iframe
                                src={process.env.REACT_APP_PHP_API_URL + `zuribuildAPI/user_websites/${website.folder_name}/`}
                                title={website.website_name}
                                className="website-iframe"
                                loading="lazy"
                                scrolling="no"
                                onLoad={() => {
                                  const placeholder = document.getElementById(`placeholder-${currentPage}-${index}`);
                                  if (placeholder) placeholder.style.display = 'none';
                                }}
                              />
                            </div>
                          </>
                        )}

                        <div className="website-gradient" />

                        <div className="website-info">
                          <p className="website-name">{website.website_name}</p>
                          <p className="website-slug">{website.folder_name}</p>
                          <div className="website-actions">
                            <button className="btn-edit-card" onClick={() => navigate(`/edit-website/${website.folder_name}`)}>
                              <i className="bi bi-pencil" style={{ marginRight: 4 }} />
                              {t("dashboard.view_and_edit")}
                            </button>
                            <button className="btn-delete-card" onClick={() => deleteWebsite(website.website_id)}>
                              <i className="bi bi-trash" />
                            </button>
                          </div>
                        </div>

                      </div>
                    ))}
                  </div>

                  {/* ── Pagination controls ── */}
                  {totalPages > 1 && (
                    <div className="pagination-wrap">

                      {/* First page */}
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(1)}
                        disabled={currentPage === 1}
                        title="First page"
                      >
                        <i className="bi bi-chevron-double-left" />
                      </button>

                      {/* Previous page */}
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                        disabled={currentPage === 1}
                        title="Previous page"
                      >
                        <i className="bi bi-chevron-left" />
                      </button>

                      {/* Page indicator */}
                      <span style={{ fontSize: 13, fontWeight: 700, color: '#333', minWidth: 64, textAlign: 'center', lineHeight: '36px' }}>
                        {currentPage} / {totalPages}
                      </span>

                      {/* Next page */}
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                        disabled={currentPage === totalPages}
                        title="Next page"
                      >
                        <i className="bi bi-chevron-right" />
                      </button>

                      {/* Last page */}
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        title="Last page"
                      >
                        <i className="bi bi-chevron-double-right" />
                      </button>

                      <span className="page-info">{websitesList.length} sites</span>
                    </div>
                  )}
                </>
              )}

            </div>
          </div>
        )}

        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      </div>

      <div ref={modalRef} style={{ backgroundColor:'rgba(0,0,0,0.6)' }}
        className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body" style={{ textAlign:'center', color:'gray' }}>
              <i className="bi bi-slash-circle" style={{ fontSize:'70px', color:'red' }}></i><br/>
              {t("dashboard.no_credit")}
            </div>
            <div className="modal-footer">
              <button type="button" onClick={goToCredit} className="btn btn-primary" style={{ background:'green' }}>{t("dashboard.btn_top_up")}</button>
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={closeModal}>{t("dashboard.btn_close")}</button>
            </div>
          </div>
        </div>
      </div>

      <button className="btn btn-secondary gear-fill" type="button" onClick={goToWizard} aria-expanded="false"
        style={{ width:'65px', height:'65px', borderRadius: '65px', padding:'5px', textAlign:'center', color:'white', backgroundColor:'green', border:'0px solid white', boxShadow:'0px 0px 6px black', position: 'fixed', bottom:'10px', right:'10px', fontSize:'40px' }}>
        +
      </button>

      <div style={{ width:'100%', height:'100vh', background:'rgba(0,0,0,0.8)', position:'fixed', top:'1px', display:showModalLoader, alignItems:'center', justifyContent:'center' }}>
        <div><Mosaic color="purple" size="small" text="loading..." textColor="white" /></div>
      </div>
  </>
  );
}